module.exports = __webpack_public_path__ + "static/media/falcon-torch-carrying-case-1.7c0675d7.jpg";